import actions from './actions';
import api from './api';
import { browserInformation } from '../../analytics/browserInformation';
import ls from 'local-storage';
import axios from 'axios';
import ReactGA from 'react-ga';

const API_URL = process.env.REACT_APP_PORTAL;
const REACT_APP_JUMIO_RETRY_WAIT_TIME = process.env.REACT_APP_JUMIO_RETRY_WAIT_TIME;
const JUMIO_FAIL_MESSAGE_MS =
  'Maaf! Pendaftaran akaun Rakan anda tidak berjaya kerana anda tidak memenuhi syarat kelayakan semasa kami. Kami berterima kasih atas minat anda dan harap anda dapat sertai komuniti Kongsi Klub kami pada masa hadapan.';
const FAIL_MESSAGE_MS = 'ada sesuatu yang tidak kena. sila cuba sebentar lagi.';
const KYC_FAIL_AND_TIMEOUT_MESSAGE_MS =
  'Kami tidak dapat memproses e-KYC anda pada masa ini. Sila cuba sebentar lagi. ';
const DETAIL_NOT_MATCH_MESSAGE_MS =
  'Butiran yang dilengkapkan tidak sepadan, sila semak butiran dan lengkapkan semula.';
const SYSTEM_FAIL_MESSAGE_MS = 'Maaf, sistem kami sedang menghadapi masalah teknikal. Sila cuba sebentar lagi.';
const GENERAL_ERROR_MESSAGE_EN = 'Sorry something went wrong. Please try again.';
const JUMIO_CALLBACK_MAX_RETRY_COUNT = process.env.REACT_APP_JUMIO_RETRY_COUNT;

const {
  signinBegin,
  signinSuccess,
  nextStep,
  setDataForm,
  forgotBegin,
  loading,
  unloading,
  setDialog,
  setTitle,
  resetDialog,
  successDialog,
  setInline,
  previous,
  kycPreFail,
  kycPostFail,
  setKycStep,
  setPWStep,
  setKycDialog,
  cddFailStatus,
  signinRefValidationFailure,
  setOTPStep,
  kycNameAndNricUpdateStatus,
  init,
  setManualRejectStep,
} = actions;

const sessionToken = (customerId, kycToken) => {
  return axios.get(`${API_URL}/signin/session?customerId=${customerId}`, {
    headers: {
      Authorization: kycToken,
    },
  });
};

const kycStatusCheck = (msisdn, type) => {
  return axios.get(`${API_URL}/signup/kyc/status?msisdn=${msisdn}&type=${type}`, {});
};

const errorDisplay = data => {
  const { error, status } = data || {};
  let param = {};

  if (error) {
    const { message, code } = error;
    const style = message.style.toLowerCase();

    const msg = message.body;
    if (style.includes('inline')) {
      param.style = 'inline';
    } else if (style.includes('overlay')) {
      const category = message.category.toLowerCase();
      const title = message.title;
      param.style = 'overlay';
      param.category = category;
      param.title = title;
    } else if (style.includes('toast')) {
      param.style = 'toast';
    } else if (style.includes('none')) {
      param.style = 'toast';
    }
    param.message = msg;
    param.code = code;
  }
  param.status = status;

  return param;
};

const getCustomDialog = (url, msg) => {
  let param = {};
  param.style = 'customDialog';
  param.message = msg;
  param.redirctUrl = url;
  console.info(param);
  return param;
};

const getRetryDialog = (msg, data, title) => {
  let param = {};
  param.style = 'retryDialog';
  param.message = msg;
  param.data = data;
  param.title = title;
  console.info(param);
  return param;
};

const signIn = param => {
  return async dispatch => {
    let browser = await browserInformation();
    let ipAddress = browser.ipv4 || '';
    param.ipAddress = ipAddress;
    param.device = {
      type: browser?.platform?.type?.toUpperCase(),
      subtype: browser?.platform?.vendor?.toUpperCase(),
    };
    dispatch(signinBegin());

    await api
      .post('/rakan/signin', param)
      .then(async res1 => {
        const { customerId, kycToken } = res1.data;

        await sessionToken(customerId, kycToken)
          .then(res => {
            console.log(res.data);
            console.log(res1.data);
            const { sessionToken } = res.data;
            ls.set('login-session', res1.data);
            ls.set('token-session', sessionToken);
            window.location.href = '/dashboard';
          })
          .catch(err => console.log(err));
      })
      .catch(err => {
        dispatch(unloading());

        if (err && err.data && err.data.error) {
          if (err.data.error.code == '1310') {
            dispatch(unloading());
            dispatch(setOTPStep());
            dispatch(setDataForm(param));
            return;
          }
          if (err.data.error.code == '3007') {
            dispatch(unloading());
            dispatch(setManualRejectStep());
            dispatch(setDataForm(param));
            return;
          }
          if (err.data.error.code == '1216') {
            dispatch(unloading());
            dispatch(nextStep());
            dispatch(setDataForm(param));
            return;
          }
        }

        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      });
  };
};

const signOut = () => {
  return async dispatch => {
    let data = ls.get('login-session');
    let customerId = data.customerId;
    let token = data.kycToken || data.sessionToken;
    let token2 = ls.get('token-session');
    // await sessionToken(customerId, token).then(async res =>{
    //   const {sessionToken} = res.data

    await axios
      .post(
        `${API_URL}/signout?customerId=${customerId}`,
        {},
        {
          headers: {
            Authorization: token2,
          },
        },
      )
      .then(res => {
        ls.remove('login-session');
        ls.remove('token-session');
        ls.clear();
        window.location.reload('/');
      })
      .catch(err => {
        ls.remove('login-session');
        ls.remove('token-session');
        ls.clear();
        window.location.reload('/');
        console.log(err);
      });
    // }).catch(err => console.log(err))
  };
};

const forgotPassword = value => {
  return async dispatch => {
    let param = {
      msisdn: value.phone,
      customerType: 'RECRUITER',
    };
    dispatch(forgotBegin());
    await api
      .post('/reset/password', param)
      .then(res => {
        dispatch(setDataForm(param));
        dispatch(loading());
        dispatch(nextStep());
        dispatch(unloading());
      })
      .catch(err => {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }

        if (err && err.data && err.data.error) {
          if (err.data.error.code == '1310') {
            dispatch(loading());
            dispatch(nextStep());
            dispatch(unloading());
          }
        }
      });
  };
};

const requestOTP = (params, toNextPage) => {
  return async dispatch => {
    dispatch(loading());
    let param = {
      type: 'RECRUITER',
      subType: 'INDIVIDUAL',
      preferredName: params.name,
      fullName: params.name,
      msisdn: params.phoneNumber,
      email: params.email,
      nric: params.nric,
      age: params.age,
      referralCode: params.referralCode,
      addressLine1: params.addressLine1,
      addressLine2: params.addressLine2,
      postcode: params.postcode,
      stateId: params.stateId,
      cityId: params.cityId,
      employmentStatus: params.employmentStatus,
      occupationType: params.occupationType,
    };
    console.log(JSON.stringify(param));
    api
      .post('/signup', param)
      .then(() => {
        dispatch(nextStep());
        dispatch(unloading());
        dispatch(setDataForm(params));
      })
      .catch(err => {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog.message == 'Your referral code is invalid') {
          dispatch(setInline(dialog));
        } else {
          dispatch(setDialog(dialog));
        }
        // if (dialog) {
        //   dispatch(setDialog(dialog))
        // }else{
        //   ask Shun Yau
        // }
        if (err.data.error.code == 3003 || err.data.error.code == 3002) {
          dispatch(signinRefValidationFailure());
        }
      });
  };
};

const resendOTP = params => {
  return async dispatch => {
    api.post('/signup/otp/resend', params).catch(err => {
      if (err && err.data && err.data.error) {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      }
    });
  };
};

const pushKyc = params => {
  return async dispatch => {
    api
      .post('/signup/kyc/reperform/ekyc', params)
      .then(res => {
        if (res.data === null) {
          let dialog = getCustomDialog('/', GENERAL_ERROR_MESSAGE_EN);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        } else {
          window.location.replace(res.data.redirectUrl);
        }
      })
      .catch(err => {
        if (err.status === 400) {
          let dialog = {};
          dialog.style = 'overlay';
          dialog.message = DETAIL_NOT_MATCH_MESSAGE_MS;
          dispatch(unloading());
          dispatch(setDialog(dialog));
        } else {
          let dialog = getCustomDialog('/', FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        }
      });
  };
};

const rePerformKyc = params => {
  return async dispatch => {
    api
      .post('/signup/kyc/verification/reprocess', params)
      .then(res => {
        if (res.data === null) {
          let dialog = getCustomDialog('/', GENERAL_ERROR_MESSAGE_EN);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        } else {
          window.location.replace(res.data.redirectUrl);
        }
      })
      .catch(err => {
        if (err.status === 400) {
          let dialog = {};
          dialog.style = 'overlay';
          dialog.message = DETAIL_NOT_MATCH_MESSAGE_MS;
          dispatch(unloading());
          dispatch(setDialog(dialog));
        } else {
          let dialog = getCustomDialog('/', FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        }
      });
  };
};

const updateNameAndNric = params => {
  return async dispatch => {
    api
      .post('/signup/kyc/resolveFailedVerification', params)
      .then(res => {
        if (res.data === null) {
          let dialog = getCustomDialog('/signup?referenceId=' + params.referenceId, GENERAL_ERROR_MESSAGE_EN);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        } else {
          let data = {
            message: `Kami memerlukan sedikit masa untuk memproses permohonan anda. Kami akan menghantar e-mel kepada anda setelah keputusan disahkan.(${res.data.errorCode})`,
          };
          dispatch(setDataForm(data));
          let param = { referenceId: params.referenceId };
          dispatch(kycPostProcess(param, JUMIO_CALLBACK_MAX_RETRY_COUNT, '/'));
        }
      })
      .catch(err => {
        if (err.status === 400) {
          let dialog = {};
          dialog.style = 'overlay';
          dialog.message = DETAIL_NOT_MATCH_MESSAGE_MS;
          dispatch(unloading());
          dispatch(setDialog(dialog));
        } else {
          let dialog = getCustomDialog('/', FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
        }
      });
  };
};

const verifyOTP = params => {
  return async dispatch => {
    api
      .post('/signup/otp/validate', params)
      .then(res => {
        ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Verify OTP' });
        const { customerId, kycToken } = res.data;
        let data = {
          customerId,
          kycToken,
        };
        dispatch(loading());
        dispatch(nextStep());
        dispatch(unloading());
        dispatch(setDataForm(data));
      })
      .catch(err => {
        if (err && err.data && err.data.error) {
          dispatch(unloading());
          let dialog = errorDisplay(err.data);
          console.log(err);
          if (dialog) {
            dispatch(setDialog(dialog));
          } else {
            //ask Shun Yau
          }
        }
      });
    // dispatch(signupErr())
  };
};

const resendOTPSignin = params => {
  return async dispatch => {
    api.post('/signin/otp/resend', params).catch(err => {
      if (err && err.data && err.data.error) {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      }
    });
  };
};

const verifyOTPSignin = params => {
  return async dispatch => {
    let browser = await browserInformation();
    let ipAddress = browser.ipv4 || '';

    params.ipAddress = ipAddress;
    params.device = {
      type: browser.platform.type,
      subtype: browser.platform.vendor,
    };

    dispatch(loading());

    await api
      .post('/signin/otp/validate', params)
      .then(res => {
        ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Verify OTP' });
        dispatch(unloading());
        dispatch(setDataForm(params));
        dispatch(setDataForm(res.data));
        ls.set('login-session', res.data);
        const { customerId, token, kycToken } = res.data;
        sessionToken(customerId, token || kycToken)
          .then(res => {
            const { sessionToken } = res.data;
            ls.set('token-session', sessionToken);
            window.location.reload();
          })
          .catch(err => console.log(err));
      })
      .catch(err => {
        if (err && err.data && err.data.error) {
          dispatch(unloading());
          let dialog = errorDisplay(err.data);
          console.log(err);
          if (dialog) {
            dispatch(setDialog(dialog));
          } else {
            //ask Shun Yau
          }
        }
      });

    // dispatch(signupErr())
  };
};

const resendOTPForgot = params => {
  return async dispatch => {
    api.post('/reset/password/otp/resend', params).catch(err => {
      if (err && err.data && err.data.error) {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      }
    });
  };
};

const verifyOTPForgot = params => {
  return async dispatch => {
    let browser = await browserInformation();
    let ipAddress = browser.ipv4 || '';

    params.ipAddress = ipAddress;
    params.device = {
      type: browser.platform.type,
      subtype: browser.platform.vendor,
    };

    await api
      .post('/reset/password/otp/validate', params)
      .then(res => {
        ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Verify OTP' });
        dispatch(loading());
        dispatch(nextStep());
        dispatch(unloading());
        dispatch(setDataForm(res.data));
      })
      .catch(err => {
        dispatch(unloading());
        let dialog = errorDisplay(err.data);
        console.log(err);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      });
    // dispatch(signupErr())
  };
};

const verifyPassword = (param, kycToken) => {
  return async dispatch => {
    dispatch(loading());
    await axios
      .put(`${API_URL}/signup?customerId=${param.customerId}`, param, {
        headers: {
          Authorization: kycToken,
        },
      })
      .then(res => {
        dispatch(nextStep());
        dispatch(unloading());
        dispatch(setDataForm(param));
      })
      .catch(err => {
        dispatch(unloading());
        let dialog = errorDisplay(err.response.data);
        console.log(err.response.data);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      });
  };
};

const switchToEkycFlow = (param, kycToken) => {
  return async dispatch => {
    dispatch(loading());
    await axios
      .post(`${API_URL}/signup/kyc/url `, param, {
        headers: {
          Authorization: kycToken,
        },
      })
      .then(res => {
        if (res.data === null) {
          dispatch(kycPreFail());
          dispatch(unloading());
        } else {
          console.log('redirecting to ->' + res.data.redirectUrl);
          window.location.replace(res.data.redirectUrl);
        }
      })
      .catch(err => {
        console.log('redirecting error ->' + err.response);
        dispatch(kycPreFail());
        dispatch(unloading());
      });
  };
};

const kycPostProcess = (param, retry, redirecturl) => {
  return async dispatch => {
    dispatch(loading());
    dispatch(setDataForm(param));
    await axios
      .post(`${API_URL}/signup/kyc/post/process`, param, {})
      .then(res => {
        if (res.data !== null) {
          console.log('Password page!');
          dispatch(setPassWordStep());
          dispatch(unloading());
          dispatch(setDataForm(res.data));
        }
      })
      .catch(err => {
        let dialog = errorDisplay(err.response.data);
        console.log('kycPostProcess error | erroe code.. ->' + dialog.code + ' | retry ->' + retry);
        if (dialog.code === 1004 && retry < JUMIO_CALLBACK_MAX_RETRY_COUNT) {
          setTimeout(function() {
            console.log('kycPostProcess error | retrying.. ->' + retry);
            dispatch(kycPostProcess(param, ++retry, redirecturl));
          }, REACT_APP_JUMIO_RETRY_WAIT_TIME);
          return;
        }
        if (dialog.code === 3004) {
          let dialog = getCustomDialog(redirecturl, JUMIO_FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
          dispatch(kycPostFailStatus());
          return;
        }
        if (dialog.code === 3005) {
          dispatch(cddFailStatus());
          dispatch(unloading());
          return;
        }
        if (dialog.code === 50001 || dialog.code === 50002 || dialog.code === 50003) {
          console.info(dialog);
          dispatch(setTitle(dialog.message));
          dispatch(setDataForm(param));
          dispatch(kycNameAndNricUpdateStatus());
          dispatch(unloading());
          return;
        }
        if (dialog.code === 6000) {
          let errorDialog = getRetryDialog(
            'Kami tidak dapat memproses e-KYC anda pada masa ini. Sila cuba sebentar lagi.',
            param,
            '',
          );
          console.info(errorDialog);
          dispatch(setTitle(dialog.message));
          dispatch(setDialog(errorDialog));
          dispatch(init());
          dispatch(unloading());
          return;
        }
        if (dialog.code === 50004) {
          let errorDialog = getRetryDialog(KYC_FAIL_AND_TIMEOUT_MESSAGE_MS, param, '[BCC004]');
          console.info(errorDialog);
          dispatch(setTitle(dialog.message));
          dispatch(setDialog(errorDialog));
          dispatch(init());
          dispatch(unloading());
          return;
        }
        if (dialog.code === 7000) {
          let errorDialog = getCustomDialog(redirecturl, `${KYC_FAIL_AND_TIMEOUT_MESSAGE_MS}(${dialog.message})`);
          dispatch(setDialog(errorDialog));
          dispatch(unloading());
          dispatch(kycPostFailStatus());
          return;
        }
        if (dialog.code === 1004 && retry >= JUMIO_CALLBACK_MAX_RETRY_COUNT) {
          let dialog = getCustomDialog(redirecturl, FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
          dispatch(kycPostFailStatus());
          return;
        }
        if (dialog.code !== 1004 || dialog.code !== 3005 || dialog.code !== 3004) {
          let dialog = getCustomDialog(redirecturl, SYSTEM_FAIL_MESSAGE_MS);
          dispatch(setDialog(dialog));
          dispatch(unloading());
          dispatch(kycPostFailStatus());
          return;
        }
      });
  };
};

const submitCddFundData = (param, retry = false) => {
  return async dispatch => {
    dispatch(loading());
    await axios
      .post(`${API_URL}/signup/kyc/cdd/process`, param, {})
      .then(res => {
        if (res.data !== null) {
          console.log('Password page!');
          dispatch(setPassWordStep());
          dispatch(unloading());
          dispatch(setDataForm(param));
          dispatch(setDataForm(res.data));
        }
      })
      .catch(err => {
        let dialog = errorDisplay(err.response.data);
        console.log('CDD Data Submit error | retrying = ' + retry + ' | error =' + dialog.code);
        if (dialog.code === 1004 && !retry) {
          dispatch(setKycDialog(FAIL_MESSAGE_MS));
          dispatch(kycPostFailStatus());
          dispatch(unloading());
        } else {
          dispatch(setDialog(dialog));
          dispatch(unloading());
        }
      });
  };
};

const verifyPasswordReset = param => {
  return async dispatch => {
    axios
      .put(
        `${API_URL}/reset/password?customerId=${param.customerId}`,
        {
          newPassword: param.password,
        },
        {
          headers: {
            Authorization: param.kycToken,
          },
        },
      )
      .then(res => {
        dispatch(nextStep('forgotPasswordSuccess'));
        dispatch(setDataForm({ loginSession: res.data }));
      })
      .catch(err => {
        dispatch(unloading());
        let dialog = errorDisplay(err.response.data);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      });
  };
};

const submitMetadata = (params, kycToken) => {
  return async dispatch => {
    let browser = await browserInformation();
    dispatch(loading());
    console.log(kycToken);
    let result = await axios.put(`${API_URL}/signup?customerId=${params.customerId}`, params, {
      headers: {
        Authorization: kycToken,
      },
    });
    let ipAddress = browser.ipv4 || '';
    if (result.status >= 200 && result.status < 400) {
      let param2 = {
        ipAddress,
        device: {
          type: browser.platform.type,
          subtype: browser.platform.vendor,
        },
      };
      await axios
        .post(`${API_URL}/signup/activate?customerId=${params.customerId}`, param2, {
          headers: {
            Authorization: kycToken,
          },
        })
        .then(res => {
          dispatch(setDataForm({ loginSession: res.data }));
          dispatch(nextStep());
          dispatch(unloading());
        })
        .catch(err => {
          dispatch(unloading());
          if (err && err.data && err.data.error) {
            let dialog = errorDisplay(err.data);
            console.log(err);
            if (dialog) {
              dispatch(setDialog(dialog));
            } else {
              //ask Shun Yau
            }
          }
        });
    } else {
      dispatch(unloading());
      if (result && result.data && result.data.error) {
        let dialog = errorDisplay(result.err.data);
        console.log(result.err.data);
        if (dialog) {
          dispatch(setDialog(dialog));
        } else {
          //ask Shun Yau
        }
      }
    }
  };
};

const nextEvent = () => {
  return async dispatch => {
    dispatch(nextStep());
  };
};

const reduceStep = () => {
  return async dispatch => {
    dispatch(previous());
  };
};

const retryKyc = () => {
  return async dispatch => {
    dispatch(setKycStep());
  };
};

const kycPostFailStatus = () => {
  return async dispatch => {
    dispatch(kycPostFail());
  };
};

const setPassWordStep = () => {
  return async dispatch => {
    dispatch(setPWStep());
  };
};

export {
  signIn,
  signOut,
  forgotPassword,
  requestOTP,
  verifyOTP,
  verifyPassword,
  verifyPasswordReset,
  submitMetadata,
  resendOTP,
  resendOTPSignin,
  verifyOTPSignin,
  verifyOTPForgot,
  resendOTPForgot,
  sessionToken,
  nextEvent,
  reduceStep,
  switchToEkycFlow,
  retryKyc,
  kycPostProcess,
  submitCddFundData,
  pushKyc,
  updateNameAndNric,
  rePerformKyc,
};
